import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const SERVICES = [
  { key: "limpieza", label: "Limpieza dental profunda", desc: "Eliminación de placa y sarro acumulado con ultrasonidos y pulido profesional." },
  { key: "blanqueamiento", label: "Blanqueamiento", desc: "Tratamiento de aclarado con gel profesional de baja abrasividad." },
  { key: "fluor", label: "Fluorización", desc: "Aplicación tópica de flúor para fortalecer el esmalte." },
  { key: "revision", label: "Revisión general", desc: "Chequeo completo de higiene, encías y pautas de cuidado en casa." },
  { key: "ninos", label: "Higiene infantil", desc: "Programa suave y educativo para niños desde 4 años." },
  { key: "mayores", label: "Cuidado geriátrico", desc: "Atención adaptada a personas mayores en su propio domicilio." },
];
